import { useEffect, useState } from 'react'
import type { LandingContent } from '../types/landingContent.types'
import { loadElitePlansContent } from '../content/loadElitePlansContent'
import { localLandingContent } from '../content/localLandingContent'

export function useElitePlansContent() {
  const [content, setContent] = useState<LandingContent>(localLandingContent)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    setIsLoading(true)
    loadElitePlansContent()
      .then((loaded) => {
        if (!cancelled) setContent(loaded)
      })
      .catch(() => {
        if (!cancelled) setContent(localLandingContent)
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [])

  return { content, isLoading }
}
